import type { StandardWidgetDataConfig } from "@/components/dashboard/widget-config";

function bindingFingerprint(
  deviceId: string,
  channel?: string | null,
  formula?: string | null,
  metricId?: string | null,
): string | null {
  const did = deviceId.trim();
  if (!did) {
    return null;
  }
  if (channel) {
    return `${did}|raw:${channel}`;
  }
  if (formula) {
    return `${did}|f:${formula}`;
  }
  if (metricId) {
    return `${did}|m:${metricId}`;
  }
  return null;
}

/** Matches FastAPI `app.services.alert_binding_fingerprint.alert_binding_fingerprint`. */
export function alertBindingFingerprintFromWidgetConfig(cfg: StandardWidgetDataConfig): string | null {
  return bindingFingerprint(cfg.device_id, cfg.channel, cfg.formula, cfg.metric_id);
}

/** For alert `data_source` JSON objects (same encoding as widget config). */
export function alertBindingFingerprintFromDataSource(ds: Record<string, unknown>): string | null {
  const did = typeof ds.device_id === "string" ? ds.device_id : null;
  if (!did) {
    return null;
  }
  const ch = typeof ds.channel === "string" ? ds.channel : null;
  const f = typeof ds.formula === "string" ? ds.formula : null;
  const m = ds.metric_id != null ? String(ds.metric_id) : null;
  return bindingFingerprint(did, ch, f, m);
}
